import { PropsWithChildren, ReactNode } from 'react';

import { CheckMarkIcon } from '@/components/common';

import { Alert } from './Alert';

interface IAlertSuccessProps extends PropsWithChildren {
  readonly title: string;
  readonly description?: string;
  readonly icon?: ReactNode;
}

export function AlertSuccess({
  title,
  description,
  children,
  icon,
}: IAlertSuccessProps) {
  return (
    <Alert
      icon={icon ?? <CheckMarkIcon className="w-12 text-success" />}
      title={title}
      description={description}
    >
      {children}
    </Alert>
  );
}
